module.exports = __webpack_public_path__ + "static/media/Loan_Landing.0efc99e9.svg";